import React, { useState, useMemo } from "react";
import { getYouTubeVideoId } from "../utils/helpers";
import { PlayIcon } from "../components/Icons";
import { InlineShareButtons } from "../components/ShareButton";
import MetaTags from "../components/MetaTags";

const VideosPage = ({ allArticles, lang }) => {
  const videoArticles = allArticles.filter((a) => a.youtubeUrl);
  const [currentVideo, setCurrentVideo] = useState(videoArticles[0]);
  const [hasInteracted, setHasInteracted] = useState(false);

  const currentVideoId = useMemo(
    () => (currentVideo ? getYouTubeVideoId(currentVideo.youtubeUrl) : null),
    [currentVideo]
  );

  const handleVideoSelect = (video) => {
    setCurrentVideo(video);
    setHasInteracted(true);
  };

  return (
    <main className="flex-grow container mx-auto px-4 py-8">
      <MetaTags
        title="Videos"
        description="Watch the latest news videos, interviews, and special reports from Amdavad Post."
      />
      <h1 className="text-3xl font-bold mb-6 capitalize border-b-2 border-red-600 pb-2">
        Videos
      </h1>
      {currentVideoId && (
        <div className="relative bg-black rounded-lg overflow-hidden mb-6 h-96 md:h-[500px]">
          <iframe
            className="w-full h-full"
            src={`https://www.youtube.com/embed/${currentVideoId}?autoplay=${
              hasInteracted ? 1 : 0
            }&controls=1`}
            title={currentVideo.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {videoArticles.map((video) => (
          <div
            key={video.id}
            onClick={() => handleVideoSelect(video)}
            className="group relative rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src={`https://img.youtube.com/vi/${getYouTubeVideoId(
                video.youtubeUrl
              )}/mqdefault.jpg`}
              alt={video.title}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
              <PlayIcon />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/80 to-transparent">
              <p className="text-white text-sm font-semibold leading-tight h-10 overflow-hidden">
                {video.title}
              </p>
              <div className="flex justify-end mt-1" onClick={(e) => e.stopPropagation()}>
                <InlineShareButtons
                  url={`${window.location.origin}/news/${video.slug || video.id}`}
                  title={video.title}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
};

export default VideosPage;
